var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-subheader',{class:`${_vm.backgroundColor} ${_vm.textColor} guest-list-header text-h6 font-weight-medium`},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }